import { render, staticRenderFns } from "./BrokerageNotes.vue?vue&type=template&id=23af8846&scoped=true"
import script from "./BrokerageNotes.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrokerageNotes.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BrokerageNotes.vue?vue&type=style&index=0&id=23af8846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af8846",
  null
  
)

export default component.exports